<ng-container *mpHeaderElement="'left'">
  <mp-root-module-nav label="Industriekataloge" [rootModuleLink]="['../']" [exact]="true" />
  <mp-navigate-back-button (navigateBackClick)="close()" />
</ng-container>

<mp-view [isCustomHeader]="true" [submittable]="form.valid && hasFormValueChanged()" (send)="update()">
  <ng-container *ngrxLet="katalog$ as katalog">
    <ng-container *ngrxLet="hasManageIndustryCatalogsPermission() as canWrite">
      <ng-container *ngrxLet="catalogsOpenTasks$ as openTasks">
        @if ((isLoading$ | async) === false && !!katalog) {
          <div class="katalog-head">
            <div class="katalog-head-main">
              @if (disabledAfterSave) {
                <mp-alert type="info">
                  <mat-icon mpAlertIcon>info</mat-icon>
                  <h4 mpAlertTitle>Industriekatalog wird aktualisiert</h4>
                  Der Industriekatalog wird gerade aktualisiert und freigegeben. Bitte lade die Seite in ein paar
                  Sekunden neu.
                </mp-alert>
              }

              <div class="action-row">
                <form [formGroup]="form">
                  <div class="action-row__selectors">
                    <mpsm-catalog-supplier-selector
                      class="lieferant-select"
                      [catalogType]="katalog?.type"
                      [editMode]="canWrite && katalog.status === 'NotAssigned'"
                      [disabled]="!canWrite || disabledAfterSave"
                      [platformSuppliers]="platformSuppliers()"
                      [isLoadingPlatformSuppliers]="isLoadingPlatformSuppliers()"
                      [supplier]="katalog?.supplier"
                      (searchTermChange)="onSearchTermChange($event)"
                      (supplierChange)="onLieferantChanges($event)"
                    />

                    <mp-dropdown
                      [options]="catalogTypeOptions"
                      formControlName="catalogType"
                      label="Katalogtyp"
                      [disabled]="!canWrite"
                    />
                  </div>
                </form>
              </div>

              <div class="data-row">
                <div class="item">
                  <span class="item__label">Name:</span>
                  <span class="item__value truncate">{{ katalog?.name }}</span>
                </div>

                <div class="item">
                  <span class="item__label">Quelle:</span>
                  <span class="item__value truncate">{{ katalog?.dataSource }}</span>
                </div>
              </div>

              @if (openTasks) {
                <div class="data-row catalog-task-wrapper">
                  @if (openTasks.supplierAssignment) {
                    <mp-catalog-task
                      [openTask]="openTasks.supplierAssignment"
                      (click)="navigateTo('supplier')"
                      icon="local_shipping"
                      label="Bezugsquellen"
                    />
                  }

                  @if (openTasks.manufacturerAssignment) {
                    <mp-catalog-task
                      [openTask]="openTasks.manufacturerAssignment"
                      (click)="navigateTo('manufacturer')"
                      icon="factory"
                      label="Hersteller"
                    />
                  }

                  @if (openTasks.packagingUnitsAssignment) {
                    <mp-catalog-task
                      [openTask]="openTasks.packagingUnitsAssignment"
                      (click)="navigateTo('packagingUnits')"
                      icon="straighten"
                      label="Packungseinheiten"
                    />
                  }
                </div>
              }
            </div>

            <div class="katalog-head-aside">
              <div class="top-row">
                <div class="head-block">
                  <h2 class="head-block__count">
                    {{ katalog?.articleTotalCount | number }}
                  </h2>
                  <h4 class="head-block__label">Artikel importiert</h4>
                </div>

                <div class="head-block">
                  <mp-catalog-covin-badge
                    class="head-block__covin-badge"
                    [value]="katalog?.covinRate"
                    [hideLabel]="true"
                  />
                  <h4 class="head-block__label-covin">Covin-Konform</h4>
                </div>
              </div>

              <div class="datatable">
                <div class="meta-item">
                  <span class="meta-item__label">Letzter Import:</span>
                  <span class="meta-item__value">{{
                    katalog?.lastStaging | humanizeRelativeDate: { whenInRange: { days: 2 } }
                  }}</span>
                </div>

                <div class="meta-item">
                  <span class="meta-item__label">Artikel mit Bildern:</span>
                  <span class="meta-item__value">{{ katalog?.articleWithPicturesCount | number }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="katalog-body">
            <mat-tab-group mat-stretch-tabs="false">
              <mat-tab label="Aufgaben">
                <mp-tab-aufgaben
                  [canWrite]="canWrite"
                  [hersteller]="(kataloghersteller$ | async) ?? []"
                  [herstellerPagination]="(herstellerPagination$ | async) ?? undefined"
                  [isLoadingPlatformSuppliers]="isLoadingPlatformSuppliers()"
                  [lieferanten]="(kataloglieferanten$ | async) ?? []"
                  [lieferantenPagination]="(lieferantenPagination$ | async) ?? undefined"
                  [openTasks]="openTasks"
                  [packagingUnitPagination]="(packagingUnitPagination$ | async) ?? undefined"
                  [packungseinheiten]="(packungseinheiten$ | async) ?? { mappings: [], units: [] }"
                  [platformSuppliers]="platformSuppliers()"
                  [schreibrecht4Packungseinheiten]="hasManagePlatformPackagingUnitsPermission()"
                  (deleteClicked)="updateLieferantOrHersteller($event)"
                  (saveClicked)="updateLieferantOrHersteller($event)"
                  (saveEinheitenMapping)="updateEinheiten($event)"
                  (supplierSearchTermChange)="onSearchTermChange($event)"
                  (pageChanges)="getNextPage($event)"
                  (packagingUnitPageChanges)="getNextPackagingUnitPage($event)"
                />
              </mat-tab>

              <mat-tab label="Validierungsergebnisse" disabled />
              <mat-tab label="Artikelvorschau" disabled />
            </mat-tab-group>
          </div>
        } @else {
          <mp-spinner />
        }
      </ng-container>
    </ng-container>
  </ng-container>
</mp-view>
